var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.093 13.374.626-3.98h-3.858V6.809c0-1.088.538-2.152 2.26-2.152h1.78v-3.39A21.563 21.563 0 0 0 14.769 1C11.593 1 9.52 2.909 9.52 6.36v3.035H6v3.98h3.52V23h4.34v-9.626h3.233Z",
    fill: "currentColor"
  })));
};
export default SvgFacebook;